import { render } from "./mega-nav.vue?vue&type=template&id=1891085b"
import script from "./mega-nav.vue?vue&type=script&lang=js"
export * from "./mega-nav.vue?vue&type=script&lang=js"

import "./mega-nav.vue?vue&type=style&index=0&id=1891085b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__